module.exports = __webpack_public_path__ + "static/img/GSK-Rare-CRS.10366d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/main/GSK-Rare-CRS.png
// module id = jFrC
// module chunks = 0